import React, { useState, useRef, useEffect } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import ReactPlayer from "react-player/youtube";
import Slider from "react-rangeslider";
import { ProgressBar, Row, Col } from "react-bootstrap";
import RespIm from "./RespIm";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-rangeslider/lib/index.css";
import "../css/video.css";
var intervalId = 0;
var duration = "";
function getWindowDimensions() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  //const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function VerVideo(props) {
  const [fullScreen, setFullScreen] = useState(true); //pongo treu porque parece que esta entrando al onChange del fullscreen al iniciar
  const [vidDim, setVidDim] = useState({});
  const dim = () => {
    var D = getWindowDimensions();
    var W = D.width;
    var H = D.height;
    var x = 0;
    var y = 0;
    var xVid = 0;
    var yVid = 0;
    var top = 0;
    var z = 0;
    if (fullScreen) {
      x = W;
      y = Math.round((x * 9) / 16);
      if (y > H) {
        y = H;
        x = Math.round((y * 16) / 9);
      }
      xVid = x;
      if (x < 408) {
        yVid = 310;
      } else {
        yVid = Math.round((xVid * 9) / 12);
      }
      top = Math.round((yVid - y) / 2);
      z = Math.round((H - y) * 0.3);
      if (z > 30) {
        z = z - 30;
      }
      z = 0;
    } else {
      if (W > H) {
        x = Math.round(0.6 * W);
        y = Math.round((x * 9) / 16);
        if (y > H) {
          y = H;
          x = Math.round((y * 16) / 9);
        }
      } else {
        x = W;
        y = Math.round((x * 9) / 16);
      }
      xVid = x;
      y = Math.round((x * 9) / 16);
      if (x < 640) {
        if (x < 408) {
          yVid = 310;
        } else {
          yVid = Math.round((xVid * 10) / 12);
        }
      } else {
        yVid = Math.round((xVid * 9) / 12);
      }
      top = Math.round((yVid - y) / 2);
      z = Math.round((H - y) * 0.1);
      if (z > 30) {
        z = z - 30;
      }
    }
    setVidDim({
      x: x,
      y: y,
      top: top,
      xx: xVid,
      yy: yVid,
      z: z,
    });
  };
  useEffect(() => {
    dim();
  }, [fullScreen]);

  useEffect(() => {
    function handleResize() {
      dim();
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handle = useFullScreenHandle();
  const videoRef = useRef(null); //Ref a ReactPlayer
  const [playing, setPlaying] = useState(false); //un state para el vide
  const [played, setPlayed] = useState(0); //
  const [show, setShow] = useState("none"); //un state para lidiar con mostrar o no los controles
  const [count, setCount] = useState(0); //un state para el tiempo activo de los controles
  const countRef = useRef(count); // Referencia al count para acceder desde interval
  countRef.current = count;
  const [seeking, setSeeking] = useState(false); //
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [volume, setVolume] = useState(70);
  const [showVol, setShowVol] = useState(true);
  function formatTime(tiempo) {
    var hora = Math.floor(tiempo / 3600);
    var min = Math.floor((tiempo - hora * 3600) / 60);
    var secs = Math.floor(tiempo - min * 60 - hora * 3600);
    var output = "";
    if (hora > 0) {
      if (min < 10) {
        if (secs < 10) {
          output = hora + ":0" + min + ":0" + secs;
        } else {
          output = hora + ":0" + min + ":" + secs;
        }
      } else {
        if (secs < 10) {
          output = hora + ":" + min + ":0" + secs;
        } else {
          output = hora + ":" + min + ":" + secs;
        }
      }
    } else {
      if (secs < 10) {
        output = min + ":0" + secs;
      } else {
        output = min + ":" + secs;
      }
    }
    return output;
  }
  const handleProgress = (state) => {
    if (duration === "") {
      duration = formatTime(videoRef.current.getDuration());
    }
    if (!seeking) {
      setPlayed(state.played);
      setTimeElapsed(
        formatTime(videoRef.current.getCurrentTime()) + " / " + duration
      );
    }
  };
  const handleVolume = (value) => {
    setVolume(value);
  };
  const handleEnd = (state) => {
    setPlaying(false);
  };
  function handleLight() {
    if (playing) {
      return false;
    } else {
      return require("../images/Logo.jpg").default;
    }
  }
  const handlePausePlay = () => {
    setPlaying(!playing);
  };
  const handlePlay = (e) => {
    var rect = e.target.getBoundingClientRect();
    var x = Math.abs((e.clientX - rect.left) / vidDim.x - 0.5); //x position within the element.//setSeeking(true);
    var y = Math.abs((e.clientY - rect.top) / vidDim.y - 0.5); //x position within the element.//setSeeking(true);

    if (vidDim.x > 500) {
      if (x < 0.05 && y < 0.05) {
        setPlaying(true);
      } else {
        handleShow();
      }
    } else {
      if (x < 0.1 && y < 0.1) {
        setPlaying(true);
      } else {
        handleShow();
      }
    }
  };
  const handleShowVol = () => {
    if (showVol === "none") {
      setShowVol("block");
    } else {
      setShowVol("none");
    }
  };

  const handleProgressClick = (value) => {
    setSeeking(true);

    setPlayed(value / 100, () => {
      setSeeking(false);
    });
    //setSeeking(false);
    videoRef.current.seekTo(value / 100);
  };

  function handleShow() {
    setCount(0);
    if (intervalId === 0) {
      setShow("block");
      intervalId = setInterval(() => {
        handleCount();
      }, 1000);
    } else {
    }
  }
  const handleFullScreen = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };
  const handleClose = () => {
    if (intervalId !== 0) {
      clearInterval(intervalId);
      intervalId = 0;
    }
    props.setEstado({
      n: 10,
      data: { nombre: props.estado.data.nombre, url: "" },
    });
  };

  const handleCount = () => {
    if (countRef.current > 2) {
      clearInterval(intervalId);
      setShow("none");
      setShowVol("none");
      intervalId = 0;
    } else {
      // console.log(show.count);
      setCount((prevCount) => prevCount + 1);
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: "100%",
          backgroundColor: "#6e3a50",
          paddingTop: "2px",
          paddingBottom: "2px",
        }}
      >
        <Row className="align-items-center">
          <Col xs={2} xl={3} className="justify-content-left">
            <RespIm
              x0={723}
              y0={172}
              x={Math.round(vidDim.x * 0.35)}
              src={require("../images/logo_white_post_horiz.png").default}
            />
          </Col>
          <Col
            xs={12}
            xl={9}
            style={{ backGroundColor: "black" }}
            className="align-items-right"
          >
            <div class="nombreVideo"> {props.estado.data.vidName}</div>
          </Col>
        </Row>
      </div>

      {}
      <FullScreen handle={handle} onChange={() => setFullScreen(!fullScreen)}>
        <div
          style={{
            paddingTop: vidDim.z,
          }}
        >
          <div
            style={{
              margin: "auto",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: vidDim.x,
                height: vidDim.y + vidDim.top,
                position: "relative",
                marginTop: -vidDim.top,
                overflow: "hidden",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <ReactPlayer
                ref={videoRef}
                url={props.estado.data.url}
                controls={false}
                playing={playing}
                width={vidDim.xx}
                height={vidDim.yy}
                light={handleLight()}
                onProgress={handleProgress}
                onEnded={handleEnd}
                volume={volume / 100}
              />

              <img
                style={{
                  position: "absolute",
                  bottom: Math.round(vidDim.y / 2 - vidDim.y / 2.5 / 2),
                  left: Math.round(vidDim.x / 2 - vidDim.y / 2.5 / 2),
                  display: playing ? "none" : "block",
                }}
                width={Math.round(vidDim.y / 2.5)}
                height={Math.round(vidDim.y / 2.5)}
                src={require("../images/play_icon.png").default}
                onClick={handlePausePlay}
              />

              <div
                class="noselect"
                style={{
                  width: vidDim.x,
                  height: vidDim.y,
                  position: "absolute",
                  opacity: 0,
                  top: vidDim.top,
                  margin: "auto",
                }}
                onClick={handlePlay}
              ></div>

              <div
                style={{
                  width: vidDim.x + 1,
                  height: vidDim.y,
                  position: "absolute",
                  top: vidDim.top,
                  display: show,
                  opacity: 0.4,
                  backgroundColor: "black",
                }}
              ></div>
              <div
                style={{
                  width: vidDim.x + 1,
                  height: vidDim.y,
                  position: "absolute",
                  top: vidDim.top,
                  display: show,
                }}
              >
                <div
                  class="duration"
                  style={{ display: timeElapsed === 0 ? "none" : "block" }}
                >
                  {timeElapsed}
                </div>{" "}
                <div
                  style={{
                    width: "100%",
                    position: "absolute",
                    bottom: "1px",
                    margin: 0,
                  }}
                >
                  <Slider
                    value={played * 100}
                    onChange={handleProgressClick}
                    tooltip={false}
                  />
                </div>
                <img
                  style={{
                    position: "absolute",
                    top: "2%",
                    left: "2%",
                  }}
                  alt="Back"
                  width="25px"
                  height="25px"
                  src={require("../images/back_icon.png").default}
                  onClick={() => {
                    handleClose();
                  }}
                />
                <img
                  class="fullScreen"
                  src={require("../images/fullScreen_icon.png").default}
                  onClick={handleFullScreen}
                  alt="FullScreen"
                />
                <img
                  class="volumen"
                  width="25px"
                  height="25px"
                  src={require("../images/vol_icon.png").default}
                  onClick={handleShowVol}
                />
                <div
                  class="volumenContainer"
                  style={{
                    display: showVol,
                  }}
                >
                  <Slider
                    style={{ backGroundColor: "#6e3a50", height: "50px" }}
                    value={volume}
                    orientation="vertical"
                    onChange={handleVolume}
                    tooltip={false}
                  />
                </div>
                <img
                  style={{
                    position: "absolute",
                    bottom: Math.round(vidDim.y / 2 - vidDim.y / 2.5 / 2),
                    left: Math.round(vidDim.x / 2 - vidDim.y / 2.5 / 2),

                    display: playing ? "block" : "none",
                  }}
                  width={Math.round(vidDim.y / 2.5)}
                  height={Math.round(vidDim.y / 2.5)}
                  src={require("../images/pause_icon.png").default}
                  onClick={handlePausePlay}
                />
                <img
                  style={{
                    position: "absolute",
                    bottom: Math.round(vidDim.y / 2 - vidDim.y / 2.5 / 2),
                    left: Math.round(vidDim.x / 2 - vidDim.y / 2.5 / 2),
                    display: playing ? "none" : "block",
                  }}
                  width={Math.round(vidDim.y / 2.5)}
                  height={Math.round(vidDim.y / 2.5)}
                  src={require("../images/play_icon.png").default}
                  onClick={handlePausePlay}
                />
              </div>
            </div>
          </div>
        </div>
      </FullScreen>
      <button class="botones" onClick={handleClose}>
        Volver
      </button>
    </div>
  );
}
/* <ProgressBar
                  now={played * 100}
                  onClick={handleProgressClick}
                  variant="custom"
                  style={{
                    width: "100%",
                    height: "10px",
                    position: "absolute",
                    bottom: "2%",
                  }}
                />*/
